// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3235":"55213fed","5506":"86476461","6684":"6e9a8e9c","8126":"786de30e","8253":"86476461"}[chunkId] + ".chunk.css";
};